<template>
  <div class="customer-notice-detail">
    <BoardDetail
      v-if="noticeDetail"
      :board-id="id"
      :board="noticeDetail"
      list-path="/customer/notice"
    />
  </div>
</template>

<script>
import BoardDetail from "@/components/BoardDetail.vue";
import { fetchNewsAndNoticeDetail } from '@/api';

export default {
  name: 'NoticeDetail',
  components: {
    BoardDetail
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      noticeDetail: null,
      loading: false,
      error: null
    };
  },
  async created() {
    await this.loadNoticeDetail();
  },
  methods: {
    async loadNoticeDetail() {
      this.loading = true;
      this.error = null;

      try {
        const response = await fetchNewsAndNoticeDetail(this.id);
        const notice = response.data;

        // 이미지 파일 확장자 정의
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        const images = [];
        const contentsHtml = notice.contents || '';

        if (notice.attachments && notice.attachments.length > 0) {
          const sorted = notice.attachments.slice().sort((a, b) => {
            const oa = a.order != null ? Number(a.order) : 0;
            const ob = b.order != null ? Number(b.order) : 0;
            return oa - ob;
          });
          sorted.forEach(att => {
            if (att.type === 'editor' || att.type === 'main') {
              return;
            }
            const ext = att.originalname ?
              att.originalname.substring(att.originalname.lastIndexOf('.')).toLowerCase() : '';

            if (!imageExtensions.includes(ext)) {
              return;
            }

            // 본문(contents)에 이미 삽입된 이미지는 중복 노출 방지
            if (att.filename && contentsHtml.indexOf(att.filename) !== -1) {
              return;
            }
            if (att.download_url && contentsHtml.indexOf(att.download_url) !== -1) {
              return;
            }

            images.push(att.download_url);
          });
        }

        this.noticeDetail = {
          id: notice.id,
          type: notice.type,
          title: notice.title,
          contents: notice.contents,
          images: images,
          mod_dttm: notice.mod_dttm,
          created_dttm: notice.created_dttm,
          attachments: notice.attachments || []
        };

      } catch (error) {
        this.error = '데이터를 불러오는 중 오류가 발생했습니다.';
        console.error('===== API 호출 에러 =====');
        console.error('에러:', error);
        console.error('에러 상세:', error.response?.data || error.message);
        console.error('========================');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.customer-notice-detail {
  width: 100%;
  min-height: 55px;
}
</style>